import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { lastValueFrom } from 'rxjs';
import { EndPointApi } from '@helpers/endpointapi';

@Injectable({
    providedIn: 'root',
})
export class MimicGroupsService {
    private domain: string;

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    getAll(): Promise<any> {
        return lastValueFrom(this.http.get(`${this.domain}/api/mimicGroups`));
    }
}
